import { WebRoutes } from "consts/enpoints/web";
import { Step } from "ui/organizms/ECommerce/Onboarding/common";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import useFinancialInformation from "./useFinancialInformation";
import { useOnboardingApplication } from "../../hooks";

const FinancialInformation = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const financialInformation = useFinancialInformation();

    return (
        <Step
            title='Financial Information'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.HighRiskMerchant}
        >
            <HighRiskMerchant.FinancialInformation.Form
                {...financialInformation}
            />
        </Step>
    );
};

export default FinancialInformation;
// export default withApplication(FinancialInformation);
